<template lang="html">
  <main class="crops">
    <!-- <div class="left-side">
      <LeftHeader/>
      <CropBar/>
    </div> -->

    <!-- <router-view class="crop-single"/> -->
    <MobileSidebarWrapper param="crop">
      <template slot="sidebar">
        <div class="left-side">
          <LeftHeader/>
          <CropBar/>
        </div>
      </template>
      <template slot="content">
        <router-view class="crop-single"/>
      </template>
    </MobileSidebarWrapper>
  </main>
</template>

<script>
import CropBar from '@/components/crops/cropbar/CropBar'
import LeftHeader from '@/components/crops/LeftHeader'
import MobileSidebarWrapper from '@/components/common/mobile-sidebar-wrapper/MobileSidebarWrapper'

export default {
  components: {
    CropBar,
    LeftHeader,
    MobileSidebarWrapper
  },

}
</script>

<style lang="scss" scoped>

.crops {
  flex-direction: row !important;
  align-items: stretch !important;

  padding: 0 0 0 8px;
  .crop-single {
    width: calc(100% - 300px);
    padding-right: 0;
  }

  .select-base {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .left-side {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  @media(max-width:768px) {
    padding: 0;
  }
}
body[dir="rtl"] {
  .crops {
    .crop-single {
      padding: 0 8px 0 0;
    }
  }
}
</style>
